
export const formSections = {
    eligibility: {
        firstName: "",
        lastName: "",
        dateOfBirth: "",
    },
    moreInfo: {
        zipCode: "",
    },
    treat: {
        treatOptions: [],
    },
    prevent: {
        preventOptions: [],
    },
    createAccount: {
        email: "",
        confirmEmail: "",
        phone: "",
        password: "",
        confirmPassword: "",
        terms: false,
        consent: false,
    },
    shipping: {
        firstName: "",
        lastName: "",
        address1: "",
        address2: "",
        city: "",
        state: "",
        postalCode: "",
    },
    internalFormData: {
        treatQuestionOption: [],
        preventQuestionOption: [],
        eligibleId: null,
        programId: null,
        authToken: null,
        userId: null,
    },
};
